import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { Box, useMediaQuery } from '@mui/material'

// Component Imports
import MailContentList from './MailContentList'
import MailDetails from './MailDetails'
import ComposeMail from './ComposeMail'

const MailContent = props => {
  const {
    fetching,
    isBelowSmScreen,
    emailArrays,
    activeEmailArr,
    setActiveEmailArr,
    reloadMessages,
    currentPage,
    pageSize,
    totalPageCount,
    totalRecordCount,
    onPageChange,
    onPageSizeChange,
    submitting,
    handleSubmitReply,
    onSubmitNewMail
  } = props

  const { t } = useTranslation()
  const isBelowLgScreen = useMediaQuery(theme => theme.breakpoints.down('lg'))

  // States
  const [repliedMessage, setRepliedMessage] = useState(null)
  const [openCompose, setOpenCompose] = useState(false)

  const showDetailPanel = !!activeEmailArr && !isBelowLgScreen
  const showDetailDrawer = !!activeEmailArr && isBelowLgScreen

  return (
    <Box sx={{ display: 'flex', height: '100%', width: '100%', overflow: 'hidden', bgcolor: 'background.paper', borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
      {/* Email List Panel */}
      <Box sx={{
        width: showDetailPanel
          ? '440px'
          : '100%',
        minWidth: showDetailPanel
          ? '440px'
          : undefined,
        maxWidth: showDetailPanel
          ? '440px'
          : undefined,
        display: 'flex',
        flexDirection: 'column',
        borderRight: showDetailPanel
          ? '1px solid'
          : 'none',
        borderColor: 'divider',
        transition: 'width 0.2s ease',
        height: '100%'
      }}>
        <MailContentList
          fetching={fetching}
          emailArrays={emailArrays}
          activeEmailArr={activeEmailArr}
          setActiveEmailArr={setActiveEmailArr}
          setOpenCompose={setOpenCompose}
          reloadMessages={reloadMessages}
          currentPage={currentPage}
          pageSize={pageSize}
          totalPageCount={totalPageCount}
          totalRecordCount={totalRecordCount}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </Box>

      {/* Detail Panel */}
      {showDetailPanel && (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
          <MailDetails
            inline
            activeEmailArr={activeEmailArr}
            setRepliedMessage={setRepliedMessage}
            onClose={() => setActiveEmailArr(null)}
          />
        </Box>
      )}

      {/* Detail Drawer */}
      {showDetailDrawer && (
        <MailDetails
          inline={false}
          activeEmailArr={activeEmailArr}
          setRepliedMessage={setRepliedMessage}
          onClose={() => setActiveEmailArr(null)}
        />
      )}

      <ComposeMail
        title={t('mailTemplate.mailbox.send.replyTitle')}
        openCompose={!!repliedMessage}
        setOpenCompose={setRepliedMessage}
        isBelowSmScreen={isBelowSmScreen}
        onSubmit={handleSubmitReply}
        submitting={submitting}
        initialEmail={{
          ...repliedMessage,
          subject: `Re: ${repliedMessage?.subject}`,
          html: '<blockquote class="RichTextEditorTheme__quote" dir="ltr">' + repliedMessage?.bodyHtml + '</blockquote>'
        }}
        focusSubjectAfterInit
        replyMessageId={repliedMessage?.messageId}
      />

      <ComposeMail
        title={t('mailTemplate.mailbox.send.composeTitle')}
        openCompose={!!openCompose}
        setOpenCompose={setOpenCompose}
        isBelowSmScreen={isBelowSmScreen}
        onSubmit={onSubmitNewMail}
        submitting={submitting}
      />
    </Box>
  )
}

export default MailContent
